import { render, staticRenderFns } from "./HelpBox.vue?vue&type=template&id=58a67af7"
import script from "./HelpBox.vue?vue&type=script&lang=js"
export * from "./HelpBox.vue?vue&type=script&lang=js"
import style0 from "./HelpBox.vue?vue&type=style&index=0&id=58a67af7&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports